import React from "react";
import { Footer } from "../global/footer";

interface Props {
  hideFooterBanner?: boolean;
}

export const LayoutLP: React.FC<Props> = (props) => {
  return (
    <div className="layout--lp">
      {props.children}
      <Footer hideBanner={props.hideFooterBanner} />
    </div>
  );
};
